import { LargeText, SmallText } from "@components";
import { useStaticData } from "@hooks";
import { ModuleSetting, CongratsSettings, NewModuleSetting } from "@models";
import { CongratsOccasions } from "../../../../models/CongratsOccasion";
import React from "react";
import { ProductCongrats } from "@models/products/ProductCongrats";

type Props = {
	moduleSetting: ModuleSetting | NewModuleSetting;
};

export default function CongratsHeader(props: Props) {
	const { moduleSetting } = props;

	const { getCategory, getProductOfId } = useStaticData();
	const category = getCategory(moduleSetting.categories[0]);
	const product = getProductOfId("congrats") as ProductCongrats;
	const congratsSettings = moduleSetting.settings as CongratsSettings;

	const congratsOccasion =
		congratsSettings?.customOccasion ??
		product.congratsOccasions.find(
			(o) => o.id === moduleSetting.settings?.occasion
		)?.name;

	return (
		<>
			<LargeText>
				{moduleSetting.settings?.occasion === CongratsOccasions.Birthday
					? "Geburtstags-Gutschein"
					: "Gutschein"}
			</LargeText>

			{moduleSetting.settings?.occasion !== CongratsOccasions.Birthday &&
				congratsOccasion && <SmallText>{congratsOccasion}</SmallText>}

			<SmallText>{category?.name}</SmallText>
		</>
	);
}
